import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import LastSalePriceButton from "./LastSalePrice";
import {
  getOfferAmount,
  toPrimaryUnitPrice,
  toSecondaryUnitPrice,
} from "@heartinz/finance";
import { getOfferPercent } from "@heartinz/finance";
import PercentIcon from "@mui/icons-material/Percent";
import uRLs from "../../../utils/baseUtils";
import { usePermission } from "../../../context/PermissionContext";
import EditProduct from "../product/EditProduct";
import Messages from "../../../constants/Messages";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { useNetwork } from "../../../context/NetworkContext";
import ProductOverView from "../product/ProductOverView";
import {
  AddIcon,
  CheckIcon,
  CheckLgIcon,
  CloseIcon,
  CustomersSearchIcon,
  EditIcon,
  OfferIcon,
  PhoneIcon,
  SearchIcon,
} from "../../../constants/Icons";

const UpdatePrice = ({
  data,
  addToCart,
  onClose,
  offer,
  customerSearchTerm,
  customerSuggestions,
  highlightedIndex,
  showCustomerDropdown,
  selectedCustomer,
  suggestionRefs,
  customerSuggestionsRef,
  handleCustomerSearch,
  handleSelectCustomer,
  handleCustomerKeyDown,
  handleKeyPress,
  setShowCustomerDropdown,
  mode,
  noteSuggests,
  brandSuggest,
  setBrandSuggest,
  onStockChanged,
  onQuantityChanged,
  preSaleId
}) => {
  // console.log("UpdatePrice props:", {
  //   data,
  //   offer,
  // });
  // console.log(selectedCustomer);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  // console.log(mode);
  // console.log("mode", mode);
  const [productData, setProductData] = useState(data);
  const { viewOption, permission, hasPermission } = usePermission();
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [inputValues, setInputValues] = useState({
    soldprice: CurrencyConverter.toCurrency(data.saleprice || 0, "INR"),
    qty: "1",
  });   
  const [selectedUnit, setSelectedUnit] = useState(
    data?.unitConfig?.primaryUnitCode || "",
  );
  const [isOfferApplied, setIsOfferApplied] = useState(true);

  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState("");
  // const [brandSuggest, setBrandSuggest] = useState([]);
  const [noteSuggest, setNoteSuggest] = useState([]);

  const [productStockData, setPrductStockData] = useState([]);

  const [discountPercent, setDiscountPercent] = useState("");
  const [isEditingPercent, setIsEditingPercent] = useState(false);
  const [soldPriceError, setSoldPriceError] = useState("");
  const [errors, setErrors] = useState({});
  const soldPriceRef = useRef(null);
  const qtyInputRef = useRef(null);
  const buttonRef = useRef(null);
  const isInitialMount = useRef(true);
  const [priceState, setPriceState] = useState({
    mrp: data.mrp,
    baseprice: data.baseprice,
  });
  // useEffect(() => {
  //   setInputValues({
  //     soldprice: CurrencyConverter.toCurrency(
  //       data.cIndex !== undefined
  //         ? data.soldprice || data.saleprice || 0
  //         : data.saleprice || 0,
  //       "INR",
  //     ),
  //     qty: data.quantity ? String(data.quantity) : "1",
  //   });

  //   setTimeout(() => {
  //     if (data?.cIndex !== undefined) {
  //       soldPriceRef.current?.focus();
  //       soldPriceRef.current?.select();
  //     } else {
  //       qtyInputRef.current?.focus();
  //       qtyInputRef.current?.select();
  //     }
  //   }, 0);
  // }, [data]);

  const handleStockDetails = async (product) => {
    try {
      if (!checkNetwork()) return;

      const productId = product?._id;

      const response = await AxiosInstance.get(
        `module/stock/primary-store/${productId}`,
      );

      setPrductStockData(response.data?.results || []);
    } catch (error) {
      setPrductStockData([]);
      // handleError(error, showAlert);
    }
  };

  useEffect(() => {
    let salePriceSubunit =
      data.cIndex !== undefined
        ? data.soldprice || data.saleprice || 0
        : data.saleprice || 0;

    const offerPercent = Number(offer);

    if (isOfferApplied && !isNaN(offerPercent) && offerPercent > 0) {
      salePriceSubunit = getOfferAmount(salePriceSubunit, offerPercent);
    }
    const mrpValue = data.mrp || 0;
    const percent = getOfferPercent(mrpValue, salePriceSubunit);
    setDiscountPercent(percent?.toString() || "");

    setInputValues({
      soldprice: CurrencyConverter.toCurrency(salePriceSubunit, "INR"),
      qty: data.quantity ? String(data.quantity) : "1",
    });

    // ✅ ONLY RUN ON FIRST LOAD
    if (isInitialMount.current) {
      isInitialMount.current = false;

      setTimeout(() => {
        if (data?.cIndex !== undefined) {
          soldPriceRef.current?.focus();
          soldPriceRef.current?.select();
        } else {
          qtyInputRef.current?.focus();
          qtyInputRef.current?.select();
        }
      }, 0);
    }
  }, [data, offer]);
  // const handleSalePriceInputChange = (value) => {
  //   const mrp = CurrencyConverter.toCurrency(data.mrp || 0, "INR");
  //   let parsedValue = value.replace(/[^0-9.]/g, "");

  //   const numericValue = parseFloat(parsedValue);

  //   if (numericValue > mrp) {
  //     parsedValue = mrp.toString();
  //   }

  //   setInputValues((prev) => ({
  //     ...prev,
  //     soldprice: parsedValue,
  //   }));

  //   if (parsedValue !== "" && !isNaN(numericValue)) {
  //     setSoldPriceError("");
  //   }
  // };

  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  const handleUpdte = async (updatedData, imageFile, trigger = true) => {
    const original = isEditData;

    const formData = new FormData();
    let isDataChanged = false;

    const appendIfChanged = (key, newVal, oldVal, transform = (v) => v) => {
      if (newVal !== oldVal) {
        formData.append(key, transform(newVal));
        isDataChanged = true;
      }
    };

    const isPriceGroupChanged =
      updatedData?.mrp !== original?.mrp ||
      updatedData?.saleprice !== original?.saleprice ||
      updatedData?.baseprice !== original?.baseprice ||
      updatedData?.taxpercentage !== original?.taxpercentage ||
      updatedData?.isLock !== original?.isLock;

    if (isPriceGroupChanged) {
      formData.append(
        "mrp",
        CurrencyConverter.toSubunit(updatedData?.mrp, "INR"),
      );
      formData.append(
        "saleprice",
        CurrencyConverter.toSubunit(updatedData?.saleprice, "INR"),
      );
      formData.append(
        "baseprice",
        CurrencyConverter.toSubunit(updatedData?.baseprice, "INR"),
      );
      formData.append("taxpercentage", updatedData?.taxpercentage);
      formData.append("isLock", updatedData?.isLock);

      isDataChanged = true;
    }

    const newMin = CurrencyConverter.toSubunit(
      Number(updatedData?.minimumSalePrice || 0),
      "INR",
    );

    const oldMin =
      typeof original?.minimumSalePrice === "number"
        ? original.minimumSalePrice
        : CurrencyConverter.toSubunit(
            Number(original?.minimumSalePrice || 0),
            "INR",
          );

    if (newMin !== oldMin) {
      formData.append("minimumSalePrice", newMin);
      isDataChanged = true;
    }
    appendIfChanged("code", updatedData?.code, original?.code);
    appendIfChanged(
      "hsnsac",
      updatedData?.hsnsac ?? "",
      original?.hsnsac ?? "",
    );
    appendIfChanged("title", updatedData?.title, original?.title);
    // appendIfChanged("taxpercentage", updatedData.taxpercentage, original.taxpercentage);
    // appendIfChanged("isLock", updatedData.isLock, original.isLock);
    appendIfChanged("note", updatedData?.note, original?.note);
    appendIfChanged(
      "searchTag",
      updatedData?.searchTag ?? "",
      original?.searchTag ?? "",
    );
    appendIfChanged(
      "brandId",
      updatedData?.brandData?.title ?? "",
      original?.brandId ?? "",
    );
    // appendIfChanged("mrp",updatedData.mrp,original.mrp,(v) => CurrencyConverter.toSubunit(v, "INR"));
    // appendIfChanged("saleprice",updatedData.saleprice,original.saleprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
    // appendIfChanged("baseprice",updatedData.baseprice,original.baseprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
    appendIfChanged(
      "landingcost",
      updatedData?.landingcost || 0,
      original?.landingcost || 0,
      (v) => CurrencyConverter.toSubunit(v, "INR"),
    );

    const newUnit = updatedData?.unitConfig;
    const oldUnit = original?.unitConfig;

    if (
      !updatedData?.unitLocked &&
      JSON.stringify(newUnit) !== JSON.stringify(oldUnit)
    ) {
      formData.append("unitConfig", JSON.stringify(newUnit));
      isDataChanged = true;
    }
    if (imageFile instanceof File) {
      formData.append("primaryImage", imageFile);
      isDataChanged = true;
    }

    if (!isDataChanged) {
      showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);
      if (trigger) closeEditModal();
      return true;
    }
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;

      const response = await AxiosInstance.patch(
        `module/product/update-product/${updatedData._id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);

      const updatedProduct = response.data.results;

      setProductData(updatedProduct);

      setPriceState({
        mrp: updatedProduct.mrp,
        baseprice: updatedProduct.baseprice,
      });

      setInputValues((prev) => ({
        ...prev,
        soldprice: CurrencyConverter.toCurrency(
          updatedProduct.saleprice,
          "INR",
        ),
      }));

      if (trigger) closeEditModal();
      return true;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleSalePriceInputChange = (value) => {
    if (isOfferApplied) setIsOfferApplied(false);

    const mrp = CurrencyConverter.toCurrency(data.mrp || 0, "INR");

    let parsedValue = value.replace(/[^0-9.]/g, "");
    let numericValue = parseFloat(parsedValue);

    // ✅ Clamp to MRP
    if (!isNaN(numericValue) && numericValue > mrp) {
      numericValue = mrp; // 🔥 FIX: update numericValue also
      parsedValue = mrp.toString();
    }

    setInputValues((prev) => ({
      ...prev,
      soldprice: parsedValue,
    }));

    // ✅ Always use corrected numericValue
    if (!isNaN(numericValue) && numericValue > 0 && numericValue <= mrp) {
      const subunitValue = CurrencyConverter.toSubunit(numericValue, "INR");
      try {
        const percent = getOfferPercent(data.mrp || 0, subunitValue);
        setDiscountPercent(percent?.toString() || "");
      } catch (err) {
        console.warn("Offer percent calc skipped:", err.message);
      }
    }

    if (parsedValue !== "" && !isNaN(numericValue)) {
      setSoldPriceError("");
    }
  };

  const handlePercentChange = (value) => {
    if (isOfferApplied) setIsOfferApplied(false);

    // Allow only numbers + decimal
    let parsed = value.replace(/[^0-9.]/g, "");

    if (parsed.startsWith("0") && !parsed.startsWith("0.")) {
      parsed = parsed.replace(/^0+/, "");
    }

    // Prevent multiple dots
    const parts = parsed.split(".");
    if (parts.length > 2) {
      parsed = parts[0] + "." + parts[1];
    }

    // Limit to 2 decimal places
    if (parts[1]?.length > 2) {
      parsed = parts[0] + "." + parts[1].slice(0, 2);
    }

    // Max 100
    if (parseFloat(parsed) > 100) parsed = "100";

    setDiscountPercent(parsed);
    setIsEditingPercent(true);
  };

  const applyPercentage = () => {
    if (isOfferApplied) setIsOfferApplied(false);
    const mrp = data.mrp || 0;
    const percent = parseFloat(discountPercent);

    if (isNaN(percent)) return;

    const newSalePriceSubunit = getOfferAmount(mrp, percent);

    setInputValues((prev) => ({
      ...prev,
      soldprice: CurrencyConverter.toCurrency(newSalePriceSubunit, "INR"),
    }));

    setIsEditingPercent(false);
  };

  const handleUnitChange = (newUnit) => {
    if (!data?.unitConfig) return;

    const normalizedNewUnit = String(newUnit).trim();
    const secondaryUnit = String(data.unitConfig.secondaryUnitCode).trim();

    // console.log("newUnit:", normalizedNewUnit);
    // console.log("secondaryUnit:", secondaryUnit);

    // ✅ SET FIRST
    setSelectedUnit(normalizedNewUnit);

    const isSwitchingToSecondary = normalizedNewUnit === secondaryUnit;

    // console.log("isSwitchingToSecondary:", isSwitchingToSecondary);

    const currentSoldPrice = parseFloat(inputValues.soldprice) || 0;
    const numericQty = parseFloat(inputValues.qty) || 1;

    let converted;

    if (isSwitchingToSecondary) {
      // console.log("➡️ Switching to SECONDARY");
      // console.log(
      //   priceState.mrp,
      //   CurrencyConverter.toSubunit(currentSoldPrice, "INR"),
      //   priceState.baseprice,
      //   data.taxpercentage,
      //   numericQty,
      //   "SALEPRICE",
      //   data.unitConfig,
      // );
      converted = toSecondaryUnitPrice(
        priceState.mrp,
        CurrencyConverter.toSubunit(currentSoldPrice, "INR"),
        priceState.baseprice,
        data.taxpercentage,
        numericQty,
        "SALEPRICE",
        data.unitConfig,
      );
    } else {
      // console.log("➡️ Switching to PRIMARY");
      // console.log(
      //   priceState.mrp,
      //   CurrencyConverter.toSubunit(currentSoldPrice, "INR"),
      //   priceState.baseprice,
      //   data.taxpercentage,
      //   numericQty,
      //   "SALEPRICE",
      //   data.unitConfig,
      // );

      converted = toPrimaryUnitPrice(
        priceState.mrp,
        CurrencyConverter.toSubunit(currentSoldPrice, "INR"),
        priceState.baseprice,
        data.taxpercentage,
        numericQty,
        "SALEPRICE",
        data.unitConfig,
      );
    }
    // console.log("Converted result:", converted);
    const result = converted?.secondaryUnitPrice || converted?.primaryUnitPrice;

    if (!result || !result.mrp || !result.salePrice) {
      console.warn("❌ Conversion failed", converted);
      return;
    }

    setInputValues((prev) => ({
      ...prev,
      soldprice: CurrencyConverter.toCurrency(result.salePrice, "INR"),
    }));

    setPriceState({
      mrp: result.mrp,
      baseprice: result.basePrice,
    });
  };
  // const handleQtyInputChange = (value) => {
  //   let parsedValue = value.replace(/\D/g, "");
  //   let numericValue = parsedValue ? parseInt(parsedValue, 10) : "";
  //   let error = "";
  //   // === Step 1: General upper limit ===
  //   if (numericValue > 999999) {
  //     numericValue = 999999;
  //     parsedValue = "999999";
  //   }
  //   // === Step 2: In edit mode, limit to data.quantity ===
  //   if (data.cMode === "EDIT") {
  //     const maxQuantity = data?.quantity || 0;
  //     if (!isNaN(numericValue) && numericValue > maxQuantity) {
  //       // error = `Maximum quantity allowed is ${maxQuantity}.`;
  //       numericValue = maxQuantity;
  //       parsedValue = String(maxQuantity);
  //     }
  //   }
  //   // === Step 3: In stock mode, limit to stockLeft ===
  //   else if (
  //     data?.cIndex !== undefined &&
  //     data.isStock &&
  //     !isNaN(numericValue) &&
  //     numericValue > data.stockLeft
  //   ) {
  //     // error = `Only ${data.stockLeft} in stock.`;
  //     numericValue = data.stockLeft;
  //     parsedValue = String(data.stockLeft);
  //   }
  //   // === Step 4: Update quantity
  //   setInputValues((prev) => ({
  //     ...prev,
  //     qty: parsedValue,
  //   }));
  //   // === Step 5: Update error message
  //   setErrors((prevErrors) => {
  //     const updated = { ...prevErrors };
  //     if (error) {
  //       updated.qty = error;
  //     } else {
  //       delete updated.qty;
  //     }
  //     return updated;
  //   });
  // };

  const handleQtyInputChange = (value) => {
    let parsedValue;

    // ✅ If UNIT config exists allow decimal qty
    if (data?.unitConfig && uRLs?.UNIT === "true") {
      parsedValue = value.replace(/[^0-9.]/g, "");

      // prevent multiple decimals
      const parts = parsedValue.split(".");

      if (parts.length > 2) {
        parsedValue = parts[0] + "." + parts[1];
      }

      // allow only 3 digits after decimal
      if (parts[1]?.length > 3) {
        parsedValue = parts[0] + "." + parts[1].slice(0, 3);
      }
    } else {
      // ✅ Normal qty input when no unitConfig
      parsedValue = value.replace(/\D/g, "");
    }

    let numericValue = parsedValue ? parseFloat(parsedValue) : "";

    let error = "";

    // === Step 1: General upper limit
    if (numericValue > 999999) {
      numericValue = 999999;
      parsedValue = "999999";
    }

    // === OLDEDIT: can only decrease quantity
    if (data.cMode === "OLDEDIT") {
      const maxQuantity = data?.quantity || 0;

      if (!isNaN(numericValue) && numericValue > maxQuantity) {
        error = `Quantity cannot exceed ${maxQuantity}.`;
      }
    }
    // === Step 2: Edit mode check
    else if (mode !== "PROFORMA" && data.cMode === "EDIT" && data.isStock) {
      const maxQuantity =
        data.cMode === "EDIT" ? data.editableStock : data.stockLeft;

      if (!isNaN(numericValue) && numericValue > maxQuantity) {
        error = `exceed stock`;
      }
    }

    // === Step 3: Stock check
    else if (
      mode !== "PROFORMA" &&
      data?.cIndex !== undefined &&
      data.isStock &&
      !isNaN(numericValue) &&
      numericValue > data.stockLeft
    ) {
      error = `exceed stock`;
    }

    setInputValues((prev) => ({
      ...prev,
      qty: parsedValue,
    }));

    setErrors((prevErrors) => {
      const updated = { ...prevErrors };

      if (error) {
        updated.qty = error;
      } else {
        delete updated.qty;
      }

      return updated;
    });
  };

  const handleAdd = () => {
    const { soldprice, qty } = inputValues;
    const numericSoldPrice = parseFloat(soldprice);
    const numericQty = parseFloat(qty);

    if (!soldprice || isNaN(numericSoldPrice)) {
      setSoldPriceError("Enter a valid sale price.");
      soldPriceRef.current?.focus();
      return;
    }

    if (numericSoldPrice > priceState.mrp) {
      setSoldPriceError("Sale price cannot exceed MRP.");
      soldPriceRef.current?.focus();
      return;
    }

    if (!qty || isNaN(numericQty) || numericQty <= 0) {
      setErrors({ qty: "Enter a valid quantity." });
      qtyInputRef.current?.focus();
      return;
    }
    // ✅ Enforce max quantity in edit mode
    if (
      mode !== "PROFORMA" &&
      data?.cIndex !== undefined &&
      data.isStock &&
      data.cMode !== "EDIT" &&
      numericQty > data.stockLeft
    ) {
      setErrors({
        qty: `exceed stock`,
      });
      qtyInputRef.current?.focus();
      return;
    }

    if (mode !== "PROFORMA" && data.cMode === "EDIT" && data.isStock) {
      const maxQuantity = data.editableStock;

      if (numericQty > maxQuantity) {
        setErrors({
          qty: `exceed stock`,
        });
        qtyInputRef.current?.focus();
        return;
      }
    }

    if (
      mode !== "PROFORMA" &&
      data?.cIndex !== undefined &&
      data.isStock &&
      data.cMode !== "EDIT" &&
      numericQty > data.stockLeft
    ) {
      setErrors({
        qty: `exceed stock`,
      });
      qtyInputRef.current?.focus();
      return;
    }

    const newItem = {
      _id: productData._id,
      code: productData.code,
      itemNo: productData.itemNo,
      hsnsac: productData.hsnsac,
      title: productData.title,
      mrp: productData.mrp,
      saleprice: productData.saleprice,
      soldprice: CurrencyConverter.toSubunit(numericSoldPrice, "INR"),
      taxpercentage: productData.taxpercentage,
      baseprice: productData.baseprice,
      discount: productData.discount,
      taxamount: productData.taxamount,
      isLock: productData.isLock,
      isStock: productData.isStock,
      note: productData.note,
      landingcost: productData.landingcost,
      imode: productData?.imode,
      ...(productData.unitConfig && {
        unitConfig: productData.unitConfig,
        secondaryUnitSelected:
          selectedUnit === productData.unitConfig.secondaryUnitCode,
      }),

      ...(data.cIndex !== undefined && { cIndex: data.cIndex }),
      ...(data.cMode === "EDIT" && {
        oldquantity: data.oldquantity,
      }),
    };
    // console.log("newItem", newItem);
    addToCart(newItem, numericQty, false);
    onQuantityChanged?.(data?._id, numericQty);
    onClose();
  };

  const handlePaymodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  const onStockEditData = async (stockData) => {
    // existing logic
    await onStockChanged?.(stockData);
    onClose();
  };

  const hadlTrashStockData = async (stockData) => {
    // existing logic
    await onStockChanged?.();
    onClose();
  };
  // const handleUpdte = async (updatedData, imageFile, trigger = true) => {
  //   const original = isEditData;

  //   const formData = new FormData();
  //   let isDataChanged = false;

  //   const appendIfChanged = (key, newVal, oldVal, transform = (v) => v) => {
  //     if (newVal !== oldVal) {
  //       formData.append(key, transform(newVal));
  //       isDataChanged = true;
  //     }
  //   };

  //   const isPriceGroupChanged =
  //     updatedData?.mrp !== original?.mrp ||
  //     updatedData?.saleprice !== original?.saleprice ||
  //     updatedData?.baseprice !== original?.baseprice ||
  //     updatedData?.taxpercentage !== original?.taxpercentage ||
  //     updatedData?.isLock !== original?.isLock;

  //   if (isPriceGroupChanged) {
  //     formData.append(
  //       "mrp",
  //       CurrencyConverter.toSubunit(updatedData?.mrp, "INR"),
  //     );
  //     formData.append(
  //       "saleprice",
  //       CurrencyConverter.toSubunit(updatedData?.saleprice, "INR"),
  //     );
  //     formData.append(
  //       "baseprice",
  //       CurrencyConverter.toSubunit(updatedData?.baseprice, "INR"),
  //     );
  //     formData.append("taxpercentage", updatedData?.taxpercentage);
  //     formData.append("isLock", updatedData?.isLock);

  //     isDataChanged = true;
  //   }

  //   appendIfChanged("code", updatedData?.code, original?.code);
  //   appendIfChanged(
  //     "hsnsac",
  //     updatedData?.hsnsac ?? "",
  //     original?.hsnsac ?? "",
  //   );
  //   appendIfChanged("title", updatedData?.title, original?.title);
  //   // appendIfChanged("taxpercentage", updatedData.taxpercentage, original.taxpercentage);
  //   // appendIfChanged("isLock", updatedData.isLock, original.isLock);
  //   appendIfChanged("note", updatedData?.note, original?.note);
  //   appendIfChanged(
  //     "searchTag",
  //     updatedData?.searchTag ?? "",
  //     original?.searchTag ?? "",
  //   );
  //   appendIfChanged(
  //     "brandId",
  //     updatedData?.brandData?.title ?? "",
  //     original?.brandId ?? "",
  //   );
  //   // appendIfChanged("mrp",updatedData.mrp,original.mrp,(v) => CurrencyConverter.toSubunit(v, "INR"));
  //   // appendIfChanged("saleprice",updatedData.saleprice,original.saleprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
  //   // appendIfChanged("baseprice",updatedData.baseprice,original.baseprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
  //   appendIfChanged(
  //     "landingcost",
  //     updatedData?.landingcost || 0,
  //     original?.landingcost || 0,
  //     (v) => CurrencyConverter.toSubunit(v, "INR"),
  //   );

  //   const newUnit = updatedData?.unitConfig;
  //   const oldUnit = original?.unitConfig;

  //   if (
  //     !updatedData?.unitLocked &&
  //     JSON.stringify(newUnit) !== JSON.stringify(oldUnit)
  //   ) {
  //     formData.append("unitConfig", JSON.stringify(newUnit));
  //     isDataChanged = true;
  //   }
  //   if (imageFile instanceof File) {
  //     formData.append("primaryImage", imageFile);
  //     isDataChanged = true;
  //   }

  //   if (!isDataChanged) {
  //     showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);
  //     if (trigger) closeEditModal();
  //     return true;
  //   }
  //   setBtnLoading(true);
  //   try {
  //     if (!checkNetwork()) return;

  //     const response = await AxiosInstance.patch(
  //       `module/product/update-product/${updatedData._id}`,
  //       formData,
  //       { headers: { "Content-Type": "multipart/form-data" } },
  //     );

  //     showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);

  //     const updatedProduct = response.data.results;

  //     // Update product list
  //     // setProductData((prev) =>
  //     //   prev.map((p) => (p._id === updatedProduct._id ? updatedProduct : p)),
  //     // );

  //     // Update modal data
  //     setEditData(updatedProduct);

  //     // Update current values
  //     setPriceState({
  //       mrp: updatedProduct.mrp,
  //       baseprice: updatedProduct.baseprice,
  //     });

  //     setInputValues({
  //       soldprice: CurrencyConverter.toCurrency(
  //         updatedProduct.saleprice,
  //         "INR",
  //       ),
  //       qty: inputValues.qty,
  //     });

  //     setSelectedUnit(updatedProduct?.unitConfig?.primaryUnitCode || "");

  //     if (trigger) closeEditModal();
  //     return true;
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   } finally {
  //     setBtnLoading(false);
  //   }
  // };

  // const closeEditModal = () => {
  //   setEditData(null);
  //   setEditModalOpen(false);
  // };

  const openEditModal = async (cItem) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:update") ||
      permission === undefined
    ) {
      setEditData({
        ...cItem,
        mrp: cItem?.mrp,
        saleprice: cItem?.saleprice,
        discount: cItem?.discount,
        baseprice: cItem?.baseprice,
        taxamount: cItem?.taxamount,
        landingcost: cItem?.landingcost || 0,
      });
      await handleStockDetails(cItem);
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const showLandingCost = viewOption("saleSettings", "isLandingCost");

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  // console.log(data.unitConfig);
  // console.log("selectedUnit", selectedUnit);
  const getMatchedStockLeft = () => {
  if (!preSaleId || !data?.isStock || !productStockData?.length) {
    return null;
  }

  const matchedStock = productStockData.find(
    (stock) =>
      Number(stock?.stockData?.mrp) === Number(data?.mrp) &&
      Number(stock?.stockData?.saleprice) === Number(data?.saleprice) &&
      Number(stock?.stockData?.taxpercentage) ===
        Number(data?.taxpercentage)
  );

  return matchedStock ? Number(matchedStock.totalStockLeft || 0) : null;
};

const handleStock = async (product) => {
  try {
    if (!checkNetwork()) return;
    
    const hasStockLinkId = !!product?.stockLinkId;

    const endpoint = hasStockLinkId
      ? `module/stock/${product._id}`
      : `module/stock/grouped/${product._id}`;

    const response = await AxiosInstance.get(endpoint);

    let stockArray = response.data?.results || [];   
    setPrductStockData(stockArray);
  } catch (error) {
    setPrductStockData([]);
    if (error?.response?.status === 404) {
      return;
    }
    handleError(error, showAlert);
  }
};

const matchedStockLeft = getMatchedStockLeft();
  useEffect(() => {
  if (!preSaleId || !data?._id) return;
  if( data.isStock){
    handleStock(data);
  }
  }, [preSaleId, data?._id]);
  
  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">
                {data?.cIndex !== undefined ? "EditSale Price" : "Update Price"}
              </h6>

              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="d-flex justify-content-start gap-2">
                <h6 className="mb-2 bg-text">
                  <span className="badge rounded-pill bg-label-navy">
                    {productData.code}
                  </span>{" "}
                  - {productData.title}
                </h6>
                {/* <div>
                  <button
                    type="button"
                    className="btn-label-primary rounded shadow-none border-0 cursor-pointer"
                    onClick={() => {
                      setEditModalOpen(true);
                    }}
                  >
                    <i className="ng ng-ng-edit-icon"></i> Product
                  </button>
                </div> */}

                {data?.cIndex === undefined && (
                  <button
                    type="button"
                    className="btn-label-primary rounded shadow-none border-0 cursor-pointer mb-2"
                    onClick={() => openEditModal(data)}
                  >
                    <EditIcon /> Product
                  </button>
                )}
              </div>
              <div>
                <div className="d-flex align-items-center mb-3 mt-3">
                  <div style={{ width: "160px" }}>
                    <div
                      className="border rounded d-flex align-items-center ps-1"
                      style={{ height: "32px" }}
                    >
                      {/* LABEL */}
                      <span className="text-muted fs-13 ms-1 me-2">
                        Discount
                      </span>

                      {/* % SYMBOL */}
                      <span className="text-muted me-1">
                        <PercentIcon style={{ fontSize: "14px" }} />
                      </span>

                      {/* INPUT */}
                      <input
                        type="text"
                        className="form-control border-0 p-0 text-center flex-grow-1"
                        style={{
                          boxShadow: "none",
                          height: "auto",
                          background: "transparent",
                          minWidth: "10px",
                        }}
                        value={discountPercent}
                        onChange={(e) => handlePercentChange(e.target.value)}
                        placeholder="0"
                        onFocus={(e) => e.target.select()}
                        onBlur={() => {
                          if (isEditingPercent) {
                            applyPercentage();
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            applyPercentage();
                            soldPriceRef.current?.focus();
                          }
                        }}
                      />

                      {/* TICK BUTTON */}
                      {isEditingPercent && (
                        <span
                          className="btn btn-sm btn-label-success p-1  shadow-none"
                          // style={{
                          //   // height: "100%",
                          //   // width: "28px", // fixed width
                          //   lineHeight: 1,
                          // }}
                          onClick={() => {
                            applyPercentage();
                            soldPriceRef.current?.focus();
                          }}
                        >
                          <CheckLgIcon iClass={"fs-6"} />
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="flex-grow-1 d-flex justify-content-center">
                    {!showCustomerDropdown && !selectedCustomer ? (
                      <div className="d-flex justify-content-center align-items-center gap-1">
                        <p className=" mb-0 fs-13">
                          <strong>Last Sale Price :</strong>
                        </p>
                        <button
                          className="btn btn-light-primary btn-sm d-flex align-items-center gap-2 shadow-none"
                          onClick={() => setShowCustomerDropdown(true)}
                        >
                          <CustomersSearchIcon iClass={"mt-1"} />
                          Select Customer
                        </button>
                      </div>
                    ) : (
                      <div className="col-lg-4 text-center position-relative">
                        {!selectedCustomer ? (
                          <>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="search"
                                autoComplete="off"
                                ref={customerSuggestionsRef}
                                value={customerSearchTerm}
                                onChange={(e) =>
                                  handleCustomerSearch(e.target.value)
                                }
                                onKeyPress={handleKeyPress}
                                onKeyDown={handleCustomerKeyDown}
                                onFocus={() => {
                                  if (customerSuggestions.length > 0) {
                                    setShowCustomerDropdown(true);
                                  }
                                }}
                                autoFocus
                                placeholder="Search customer by name, phone, email, referenceID..."
                              />
                              <span className="input-group-text">
                                <SearchIcon />
                              </span>
                            </div>

                            {customerSearchTerm &&
                              customerSuggestions.length === 0 && (
                                <ul className="suggestions-list position-absolute w-100 bg-white border rounded shadow-sm z-3 mt-1">
                                  <li className="suggestion-item text-muted px-3 py-2">
                                    No customers data was found
                                  </li>
                                </ul>
                              )}

                            {showCustomerDropdown &&
                              customerSuggestions.length > 0 && (
                                <ul
                                  className="suggestions-list position-absolute w-100 bg-white border rounded shadow-sm z-3 mt-1"
                                  style={{
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {customerSuggestions.map(
                                    (customer, index) => (
                                      <li
                                        ref={(el) =>
                                          (suggestionRefs.current[index] = el)
                                        }
                                        key={customer._id}
                                        onClick={() =>
                                          handleSelectCustomer(customer)
                                        }
                                        className={`suggestion-item px-3 py-2 cursor-pointer ${
                                          highlightedIndex === index
                                            ? "bg-primary text-white"
                                            : ""
                                        }`}
                                      >
                                        {customer.name} -{" "}
                                        <span className="badge bg-label-blue rounded-pill">
                                          {customer.phone}
                                        </span>
                                        {customer.referenceid && (
                                          <>
                                            <small> - </small>
                                            <span className="badge bg-label-secondary rounded-pill">
                                              {customer.referenceid}
                                            </span>
                                          </>
                                        )}
                                      </li>
                                    ),
                                  )}
                                </ul>
                              )}
                          </>
                        ) : (
                          <div className="text-center border rounded bg-light">
                            <p className="mb-0 fs-14">
                              {selectedCustomer?.customerData?.name}
                            </p>
                            <p className="mb-0 fs-14">
                              <PhoneIcon iClass={"fs-14"} /> :{" "}
                              {selectedCustomer?.customerData?.phone}
                            </p>
                            <p className="mb-0 fs-14">
                              {data?._id &&
                                selectedCustomer?.customerData?._id && (
                                  <LastSalePriceButton
                                    productId={data._id}
                                    customerId={
                                      selectedCustomer?.customerData?._id
                                    }
                                  />
                                )}
                            </p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* <div className="col-md-4">
                  <div>
                    {Array.isArray(data?.recent) &&
                      data.recent.some((sale) => sale.saleitems?.[0]) &&
                      data.recent
                        .flatMap((sale) =>
                          sale.saleitems?.[0] ? [sale.saleitems[0]] : []
                        )
                        .map((product, index) => (
                          <h6 key={index} className="mb-3 bg-text text-end">
                            Last sale price:{" "}
                            <span className="badge bg-label-fall rounded-pill">
                              ₹
                              {CurrencyConverter.toCurrency(
                                product?.soldprice || 0,
                                "INR"
                              )}
                            </span>
                          </h6>
                        ))}
                  </div>
                </div> */}

              <table className="table align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="text-center">MRP</th>
                    <th className="text-center">
                      Sale Price
                      {data?.unitConfig?.primaryUnitCode && (
                        <small className="">
                          {" "}
                          / {data.unitConfig.primaryUnitCode}
                        </small>
                      )}
                      {isOfferApplied && offer > 0 && (
                        <span className="badge bg-warning text-dark ms-1">
                          <OfferIcon /> -{offer}%
                        </span>
                      )}
                    </th>
                    <th className="text-center">Tax(%)</th>
                    {showLandingCost && (
                      <th className="text-center">Landing Cost</th>
                    )}
                    {data?.cIndex !== undefined &&
                      data.isStock &&
                      data.cMode !== "OLDEDIT" && (
                        <th className="text-center">Stock left</th>
                      )}
                    <th className="text-center w-15">Qty</th>
                    {/* {data?.unitConfig && uRLs?.UNIT === "true" && (
                      <th className="text-center">Units</th>
                    )} */}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-center align-middle">
                      <div className="py-2">
                        ₹
                        {CurrencyConverter.toCurrency(
                          priceState.mrp || 0,
                          "INR",
                        )}
                      </div>
                    </td>
                    <td className="text-center wx-200">
                      <div
                        className="position-relative mx-auto"
                        style={{ width: "120px" }} // same as input width
                      >
                        <input
                          type="text"
                          name="soldprice"
                          autoComplete="off"
                          className="form-control text-center"
                          value={inputValues.soldprice}
                          onChange={(e) =>
                            handleSalePriceInputChange(e.target.value)
                          }
                          onFocus={() => {
                            setSoldPriceError("");
                            soldPriceRef.current?.select();
                          }}
                          ref={soldPriceRef}
                          maxLength={String(data.mrp).length + 2}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              qtyInputRef.current?.focus();
                            }
                          }}
                          disabled={
                            !viewOption("saleSettings", "modifySalePrice")
                          }
                        />

                        {/* {offer && (
                          <span
                            className="position-absolute text-danger"
                            style={{
                              top: "-6px",
                              right: "0px",
                              left: "120px",
                              fontSize: "10px",
                              fontWeight: "600",
                            }}
                          >
                            -{offer}%
                          </span>
                        )} */}
                      </div>

                      {soldPriceError && (
                        <div className="invalid-feedback d-block text-center">
                          {soldPriceError}
                        </div>
                      )}
                    </td>
                    <td className="text-center">
                      <span className="badge rounded-pill bg-label-peace">
                        {data.taxpercentage ? `${data.taxpercentage}%` : "0%"}
                      </span>
                    </td>
                    {showLandingCost && (
                      <td className="text-center">
                        {data?.landingcost
                          ? `₹ ${CurrencyConverter.toCurrency(data.landingcost, "INR")}`
                          : "₹ 0"}
                      </td>
                    )}
                    {data?.cIndex !== undefined &&
                      data.isStock &&
                      data.cMode !== "OLDEDIT" && (
                        <td className="text-center">
                          <span className="badge bg-label-space">
                              {preSaleId
          ? matchedStockLeft ?? 0 :data.cMode === "EDIT"
                              ? data.editableStock
                              : data.stockLeft}
                            {data?.unitConfig &&
                              uRLs?.UNIT === "true" &&
                              data.unitConfig.primaryUnitCode}
                          </span>
                        </td>
                      )}
                    <td className="wx-180">
                      <div
                        className="input-group flex-nowrap mx-auto"
                        style={{ minWidth: "140px", width: "150px" }}
                      >
                        <input
                          type="text"
                          name="quantity"
                          autoComplete="off"
                          className="form-control text-center"
                          ref={qtyInputRef}
                          value={inputValues.qty || ""}
                          onFocus={() => {
                            qtyInputRef.current?.select();
                          }}
                          onChange={(e) => handleQtyInputChange(e.target.value)}
                          onKeyDown={handlePaymodeKeyDown}
                          maxLength={10}
                        />

                        {data?.unitConfig &&
                          uRLs?.UNIT === "true" &&
                          (data?.unitConfig?.secondaryUnitCode ? (
                            <select
                              className="btn btn-unit shadow-none border-end rounded-end rounded-start-0"
                              // style={{
                              //   width: "70px",
                              //   minWidth: "70px",
                              // }}
                              value={selectedUnit}
                              onChange={(e) => handleUnitChange(e.target.value)}
                            >
                              <option value={data.unitConfig.primaryUnitCode}>
                                {data.unitConfig.primaryUnitCode}
                              </option>

                              {/* <option value={data.unitConfig.secondaryUnitCode}>
                                {data.unitConfig.secondaryUnitCode}
                              </option> */}
                            </select>
                          ) : (
                            <span
                              className="btn btn-unit shadow-none border-end rounded-end rounded-start-0"
                              // style={{
                              //   width: "70px",
                              //   minWidth: "70px",
                              // }}
                            >
                              {data.unitConfig.primaryUnitCode}
                            </span>
                          ))}
                      </div>

                      {errors.qty && (
                        <div className="invalid-feedback d-block text-center">
                          {errors.qty}
                        </div>
                      )}
                    </td>
                    {/* {data?.unitConfig && uRLs?.UNIT === "true" && (
                      <td className="text-center wx-150">
                        {data?.unitConfig ? (
                          <select
                            className="form-select text-center"
                            value={selectedUnit}
                            disabled={!data?.unitConfig?.secondaryUnitCode}
                            onChange={(e) => handleUnitChange(e.target.value)}
                          >
                            {/* Primary Unit */}
                    {/* <option value={data.unitConfig.primaryUnitCode}>
                      {data.unitConfig.primaryUnitCode}
                    </option> */}

                    {/* Secondary Unit */}
                    {/* {data.unitConfig.secondaryUnitCode && (
                              <option value={data.unitConfig.secondaryUnitCode}>
                                {data.unitConfig.secondaryUnitCode}
                              </option>
                            )} 
                          </select>
                        ) : (
                          "-"
                        )}
                      </td>
                    )} */}
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                className="btn btn-outline-secondary text-left"
              >
                <CloseIcon iClass={"fs-15"} /> Cancel
              </button>
              <button
                ref={buttonRef}
                type="button"
                className={`btn ${
                  mode === "PROFORMA" ? "btn-porforma" : "btn-primary"
                } text-right`}
                disabled={!!errors.qty || !inputValues.qty}
                onClick={handleAdd}
              >
                {data?.cIndex !== undefined ? (
                  <>
                    <CheckIcon /> Update
                  </>
                ) : (
                  <>
                    <AddIcon /> Add
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
        {/* {isEditModalOpen && (
          <EditProduct
            editData={isEditData}
            onClose={closeEditModal}
            onEdit={handleUpdte}
            isBtnLoading={isBtnLoading}
            noteSuggests={noteSuggest}
            brandSuggest={brandSuggest}
            setBrandSuggest={setBrandSuggest}
          />
        )} */}

        {isEditModalOpen && (
          <ProductOverView
            onClose={closeEditModal}
            onData={isEditData}
            onStockData={productStockData}
            onUpdate={handleUpdte}
            noteSuggests={noteSuggests}
            isBtnLoading={isBtnLoading}
            setProductData={setProductData}
            onStockEditData={onStockEditData}
            OnStockTrashData={hadlTrashStockData}
            onStockChanged={onStockChanged}
            // handleDeteleDataUpdate={handleDeteleDataUpdate}
            brandSuggest={brandSuggest}
            setBrandSuggest={setBrandSuggest}
          />
        )}
      </div>
    </div>
  );
};

export default UpdatePrice;
